export default "__VITE_ASSET__CzLWwtIw__"